import { gql, TypedDocumentNode } from '@apollo/client';

export const SEND_POST_BACK_MUTATION: TypedDocumentNode<
  { sendPostBackRequest: boolean },
  { action: string; utmPayload: Record<string, unknown> }
> = gql`
  mutation sendPostBackRequest($utmPayload: JSON!, $action: CandidateActions!) {
    sendPostBackRequest(utmPayload: $utmPayload, action: $action)
  }
`;
